export const acsBannerStripData = [
  {
    icon: 'briefcase',
    text: 'Alumni will be helping you with the current ',
    highlightedText: 'industry trends',
  },
  {
    icon: 'rocket',
    text: 'Answering your ',
    highlightedText: 'career-related questions and offering guidance',
  },
  {
    icon: 'circle-wavy-check',
    text: 'Sharing about their ',
    highlightedText: 'Scaler experience',
  },
];

export const acsBannerStripDataV2 = [
  {
    icon: 'briefcase',
    text: 'Expert will be helping you with the current ',
    highlightedText: 'industry trends',
  },
  {
    icon: 'rocket',
    text: 'Answering your ',
    highlightedText: 'career-related questions and offering guidance',
  },
  {
    icon: 'circle-wavy-check',
    text: 'Sharing about their ',
    highlightedText: 'Scaler experience',
  },
];

export const AVATAR_IMG_URL = `https://d2beiqkhq929f0.cloudfront.net/`
  + `public_assets/`
  + `assets/000/075/611/original/_avatar.webp?1717056076`;

export const ALL_AVATARS_IMG = `https://d2beiqkhq929f0.cloudfront.net/`
  + `public_assets/`
  + `assets/000/091/648/original/avatars.webp?1727688329`;
